var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBwp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.566625 8.61327C0.199031 9.76494 -4.68667e-05 10.9918 8.276e-09 12.2654C-4.68667e-05 13.539 0.199031 14.7659 0.566672 15.9176L12 16.4394L23.4333 15.9176C23.8008 14.7659 24 13.5389 24 12.2655C24 10.9919 23.8009 9.76494 23.4333 8.61327L12 8.09155L0.566625 8.61327Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12.2684C24 11.5565 23.9377 10.8592 23.8187 10.1814H0.181313C0.0623437 10.8592 0 11.5564 0 12.2684C0 12.9803 0.0623906 13.6775 0.181313 14.3553H23.8187C23.9376 13.6775 24 12.9803 24 12.2684Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 24.2676C17.3536 24.2676 21.8878 20.7612 23.433 15.9197H0.566406C2.11164 20.7612 6.64591 24.2675 11.9997 24.2676Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 0.267334C6.64595 0.267334 2.11173 3.77372 0.566406 8.61507L23.433 8.61512C21.8878 3.77373 17.3536 0.26724 11.9998 0.267334Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBwp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BWP.5a0dd567772a20c1b61589ec10161720.svg";